'use client'

import { forwardRef, ReactNode } from 'react'
import clx from 'classnames'
import { motion } from 'framer-motion'
import { useAppearance, variantsDefault } from '@/shared/utils'

type MotionHtmlElement = keyof typeof motion

interface VariantsMotion {
  visible: {
    opacity: number
    translateY: number
    transition: {
      duration: number
    }
  }
  hidden: {
    opacity: number
    translateY: number
  }
}

interface TextProps {
  className?: string | string[]
  children?: ReactNode
  tagName?: keyof HTMLElementTagNameMap
  color?: string
  type?: string
  variants?: VariantsMotion
  isAppearance?: boolean
  __html?: string
  onClick?: (props: Event) => void
}

export const Text = forwardRef<HTMLElement, TextProps>((props, ref) => {
  const {
    className,
    children,
    tagName = 'p',
    color = 'white',
    type = 't1',
    variants,
    isAppearance = false,
    __html,
    ...restProps
  } = props
  const { ref: titleRef, animate: titleAnimate } = useAppearance()
  const isAnimate = isAppearance || variants
  const Tag = (isAnimate ? motion[tagName as MotionHtmlElement] : tagName) as any
  const classList = clx(className, 'text', `text_color_${color}`, `text_type_${type}`)

  const dangerousProps = __html
    ? {
        dangerouslySetInnerHTML: { __html },
      }
    : {}

  return (
    <Tag
      className={classList}
      {...restProps}
      ref={(el: any) => {
        // @ts-ignore
        ref?.(el)
        titleRef.current = el
      }}
      initial="hidden"
      animate={titleAnimate}
      variants={isAppearance ? (variants ?? variantsDefault) : variants}
      {...dangerousProps}
    >
      {children}
    </Tag>
  )
})

Text.displayName = 'Text'
